<template>
  <section id="section-regions" class="section-regions">
    <div class="regions">
      <Card
        v-for="region in getSimulatorRegions"
        :key="region.id"
        :cardImage="region.regionPicture"
        :cardText="region.regionName"
        :region="region"
      />
    </div>
  </section>
</template>

<script>
import Card from "../UI/Card.vue";
export default {
  components: {
    Card,
  },
  computed: {
    getSimulatorRegions() {
      return this.$store.getters.getSimulators.simulatorRegions;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-regions {
  padding: 15rem 17rem;
  position: relative;
  //height: 100rem;
}

.regions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  transition: all 5s;

  &:hover .card:not(:hover) {
    transform: scale(0.9);
  }
}
</style>
